module.exports = __webpack_public_path__ + "img/cjkh.c69f4042.png";